/**
 * Critical lazy-loaded routes for immediate performance improvement
 * Focus on the largest/most expensive page components first
 */

import { createLazyRoute } from '../utils/lazy-loading';

// Core application routes that should be lazy loaded
export const LoginPage = createLazyRoute(() => 
  import(/* webpackChunkName: "auth" */ '../pages/auth/LoginPage')
);

export const RegisterPage = createLazyRoute(() => 
  import(/* webpackChunkName: "auth" */ '../pages/auth/RegisterPage')
);

export const ResetPasswordPage = createLazyRoute(() => 
  import(/* webpackChunkName: "auth" */ '../pages/auth/ResetPasswordPage')
);

export const HomePage = createLazyRoute(() => 
  import(/* webpackChunkName: "core" */ '../pages/home/HomePage')
);

export const FeedTabs = createLazyRoute(() => 
  import(/* webpackChunkName: "core" */ '../pages/feed/FeedTabs')
);

export const UnifiedTrainingLogPage = createLazyRoute(() => 
  import(/* webpackChunkName: "training" */ '../pages/training/UnifiedTrainingLogPage')
);

export const ProfilePage = createLazyRoute(() => 
  import(/* webpackChunkName: "profile" */ '../pages/profile/ProfilePage')
);

export const SettingsPage = createLazyRoute(() => 
  import(/* webpackChunkName: "settings" */ '../pages/settings/SettingsPage')
);

// AI features (potentially heavy)
export const ChatPage = createLazyRoute(() => 
  import(/* webpackChunkName: "ai" */ '../pages/ai/ChatPage')
);

export const AnalysisPage = createLazyRoute(() => 
  import(/* webpackChunkName: "ai" */ '../pages/ai/AnalysisPage')
);

export const RecommendationsPage = createLazyRoute(() => 
  import(/* webpackChunkName: "ai" */ '../pages/ai/RecommendationsPage')
);

// Premium features
export const PremiumLandingPage = createLazyRoute(() => 
  import(/* webpackChunkName: "premium" */ '../pages/premium/PremiumLandingPage')
);

export const PremiumInsightsPage = createLazyRoute(() => 
  import(/* webpackChunkName: "premium" */ '../pages/premium/PremiumInsightsPage')
);

// Admin features (should definitely be lazy loaded)
export const AdminDashboard = createLazyRoute(() => 
  import(/* webpackChunkName: "admin" */ '../pages/admin/AdminDashboard')
);

export const UserManagementPage = createLazyRoute(() => 
  import(/* webpackChunkName: "admin" */ '../pages/admin/UserManagementPage')
);

export const DatabaseManagementPage = createLazyRoute(() => 
  import(/* webpackChunkName: "admin" */ '../pages/admin/DatabaseManagementPage')
);